<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <span class="section-title">
                {{ final.id === 0 ? 'Crear' : 'Editar' }} Registro Final
              </span>
              <argon-button color="warning" size="sm" class="ms-auto" @click="save">
                Guardar
              </argon-button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">

              <!-- Fecha del Producto -->
              <div class="col-md-6">
                <label class="form-control-label">Fecha del producto</label>
                <argon-input type="date" v-model="final.product_date" />
              </div>

              <!-- Cantidad Final -->
              <div class="col-md-6">
                <label class="form-control-label">Cantidad final</label>
                <argon-input type="number" v-model="final.final_quantity" />
              </div>

              <!-- Calidad del Producto -->
              <div class="col-md-6">
                <label class="form-control-label">Calidad del producto</label>
                <argon-input type="text" v-model="final.product_quality" />
              </div>

              <!-- Ubicación de Almacenamiento (Select2) -->
              <div class="col-md-6 bodega-select-wrapper">
                <label class="form-control-label">Ubicación de almacenamiento</label>
                <select ref="selectBodega" class="form-control" v-model="final.bodega_id">
                  <option value="" disabled>Seleccione una bodega</option>
                  <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                    {{ bodega.name }}
                  </option>
                </select>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.min.css';
import 'select2';

export default {
  name: "MinesExtractionsFinal",
  data() {
    return {
      final: {
        id: 0,
        mines_extractions_id: '',
        product_date: '',
        final_quantity: 0,
        product_quality: '',
        bodega_id: '',
        storage_location: '',
        observation: 'Test',
      },
      form: {
        id: 0,
        mines_extractions_id: '',
        name: '',
        location: '',
        extraction_date: '',
        extracted_quantity: '',
        equipment_used: '',
        worker: '',
        quality: '',
        humidity: '',
        notes: ''
      },
      bodegas: [],
    };
  },
  components: {
    ArgonInput,
    ArgonButton,
  },
  methods: {
    async loadFinal(id) {
      try {
        const response = await this.$store.dispatch("minesExtractionsFinal/getData", id);
        this.final = { ...this.final, ...response.data };
        this.$nextTick(() => {
          if (this.$refs.selectBodega && $(this.$refs.selectBodega).data('select2')) {
            $(this.$refs.selectBodega).val(this.final.bodega_id || '').trigger('change');
          }
        });
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar la información.',
        });
      }
    },
    async save() {
      try {
        if (!this.final.product_date || !this.final.product_quality || !this.final.bodega_id || Number(this.final.final_quantity) <= 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Advertencia',
            text: 'Completa todos los campos antes de guardar.',
          });
          return;
        }
        const response = await this.$store.dispatch("minesExtractionsFinal/save", this.final);
        if (response && response.status >= 200 && response.status < 300) {
          Swal.fire({
            icon: 'success',
            title: 'Éxito',
            text: `Final ${this.final.id === 0 ? 'creado' : 'actualizado'} correctamente`,
            confirmButtonText: 'Aceptar',
          }).then(() => {
            this.$router.push({
              name: 'Extraction Create',
              params: {
                id: this.final.mines_extractions_id,
                data: JSON.stringify(this.form)
              },
              query: { tab: 2 }
            });
          });
        } else {
          throw new Error(response?.data?.message || 'Ocurrió un error');
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar la información final',
        });
      }
    },
    async getUsers() {
      const response = await this.$store.dispatch("users/getAll");
      this.users = response;
    },
    async getDataExtraction() {
      const id = this.final.mines_extractions_id;
      if (!id) return;
      try {
        const response = await this.$store.dispatch("minesExtractions/getData", id);
        this.form = { ...this.form, ...response.data };
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll');
    },
  },
  mounted() {
    const data = this.$route.params.data;
    if (data) {
      try {
        const params = JSON.parse(data);
        if (params.id > 0) {
          this.final = { ...this.final, ...params };
        } else {
          this.final.mines_extractions_id = params.mines_extractions_id;
          // Fecha del producto automática al crear
          const today = new Date();
          const y = today.getFullYear();
          const m = String(today.getMonth() + 1).padStart(2, '0');
          const d = String(today.getDate()).padStart(2, '0');
          this.final.product_date = `${y}-${m}-${d}`;
        }
      } catch (error) {
        console.error("Error al parsear datos:", error);
      }
    }
    this.getDataExtraction();
    this.getBodegas().then(() => {
      this.$nextTick(() => {
        if (!this.$refs.selectBodega) return;
        $(this.$refs.selectBodega).select2({
          placeholder: 'Seleccione una bodega',
          allowClear: true,
        }).on('select2:select', (e) => {
          this.final.bodega_id = e.target.value;
        }).on('select2:clear', () => {
          this.final.bodega_id = '';
        });
        if (this.final.bodega_id) {
          $(this.$refs.selectBodega).val(this.final.bodega_id).trigger('change');
        }
      });
    });
    this.loadFinal(this.final.id);
    setNavPills();
    setTooltip();
  },
  beforeUnmount() {
    if (this.$refs.selectBodega && $(this.$refs.selectBodega).data('select2')) {
      $(this.$refs.selectBodega).select2('destroy');
    }
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 800;
  color: #1f2d5a;
  letter-spacing: 0.6px;
}

.section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

:deep(.bodega-select-wrapper .select2-container) {
  font-size: 0.875rem !important;
}
:deep(.bodega-select-wrapper .select2-selection__rendered),
:deep(.bodega-select-wrapper .select2-selection__placeholder) {
  font-size: 0.875rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
}
:deep(.bodega-select-wrapper .select2-selection__placeholder) {
  color: #6c757d !important;
}
</style>
